// =======================================
//   IntersectionObserver Polyfill (Infinite Scroll)
// =======================================
(function () {
  if ("IntersectionObserver" in window) return;

  window.IntersectionObserver = class {
    constructor(callback, options = {}) {
      this.callback = callback;
      this.options = options;
      this.target = null;

      this.handleEvent = this.check.bind(this);

      window.addEventListener("scroll", this.handleEvent);
      window.addEventListener("resize", this.handleEvent);
    }

    observe(target) {
      this.target = target;
      this.check();
    }

    unobserve() {
      this.target = null;
    }

    disconnect() {
      window.removeEventListener("scroll", this.handleEvent);
      window.removeEventListener("resize", this.handleEvent);
      this.target = null;
    }

    check() {
      if (!this.target) return;

      const rect = this.target.getBoundingClientRect();

      const isIntersecting =
        rect.top <= window.innerHeight &&
        rect.bottom >= 0;

      if (isIntersecting) {
        this.callback(
          [
            {
              target: this.target,
              isIntersecting: true,
              intersectionRatio: 1,
            },
          ],
          this
        );
      }
    }
  };
})();